import React from 'react';

const OutlineContext = React.createContext();

export default OutlineContext;